import { Component, OnInit, ViewChild } from '@angular/core';
import { ColDef, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { RequestService } from 'src/app/services/requests.service';
import { AgGridAngular } from 'ag-grid-angular';
import { Router } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: 'search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {

  public fileName: any = '';
  public experiments: any = [];
  public id: any = '';

  public sensorId: any = '';
  public sensorGridApi;
  public sensorGridColumnApi;
  public sensorRowData: any[];

  public biologicalId: any = '';
  public biologicalGridApi;
  public biologicalGridColumnApi;
  public biologicalRowData: any[];

  public literatureId: any = '';
  public literatureGridApi;
  public literatureGridColumnApi;
  public literatureRowData: any[];

  public physicochemicalId: any = '';
  public physicochemicalGridApi;
  public physicochemicalGridColumnApi;
  public physicochemicalRowData: any[];

  public sensorColDefs: ColDef[] = [
    { field: 'pilot_code', headerName: "DiTect Pilot" },
    { field: 'country', headerName: "Country" },
    { field: 'partner' },
    { field: 'primary_production', headerName: "Primary Production", valueFormatter: this.booleanFormatter },
    { field: 'manufacturing_processing', headerName: "Manufacturing-Processing", valueFormatter: this.booleanFormatter },
    { field: 'packaging_storage', headerName: "Packaging-Storage", valueFormatter: this.booleanFormatter },
    { field: 'distribution_retail', headerName: "Distribution-Retail", valueFormatter: this.booleanFormatter },
    { field: 'device', headerName: "Device" },
    { field: 'laboratory', headerName: "Laboratory" },
  ];

  public bioColDefs: ColDef[] = [
    { field: 'pilot_code', headerName: "DiTect Pilot" },
    { field: 'country', headerName: "Country" },
    { field: 'partner' },
    { field: 'primary_production', headerName: "Primary Production" },
    { field: 'manufacturing_processing', headerName: "Manufacturing-Processing" },
    { field: 'packaging_storage', headerName: "Packaging-Storage" },
    { field: 'distribution_retail', headerName: "Distribution-Retail" },
    { field: 'device', headerName: "Device" },
    { field: 'laboratory', headerName: "Laboratory" },
  ];

  public physicoColDefs: ColDef[] = [
    { field: 'pilot_code', headerName: "DiTect Pilot" },
    { field: 'country', headerName: "Country" },
    { field: 'partner' },
    { field: 'primary_production', headerName: "Primary Production" },
    { field: 'manufacturing_processing', headerName: "Manufacturing-Processing" },
    { field: 'packaging_storage', headerName: "Packaging-Storage" },
    { field: 'distribution_retail', headerName: "Distribution-Retail" },
    { field: 'device', headerName: "Device" },
  ];

  public litColDefs: ColDef[] = [
    { field: 'compendium_id', headerName: "No.", width: 100 },
    { field: 'hazard/stage', headerName: "Hazard/stage", width: 100 },
    { field: 'author', headerName: "Author" },
    { field: 'year', headerName: "Year" },
    { field: 'country', headerName: "Country" },
    { field: 'title', headerName: "Title", minWidth: 1000, },
    { field: 'doi', headerName: "DOI" },
    { field: 'notes', headerName: "Notes" },
  ];

  public defaultColDef: ColDef = {
    flex: 0,
    filter: true,
    resizable: true,
    filterParams: {
      buttons: ['reset', 'apply'],
      filterOptions: ["contains", "notContains"],
    },
  }

  public gridOptions: GridOptions = {
    pagination: true,
    animateRows: true,
    paginationPageSize: 25,
    rowSelection: 'single',
  }

  @ViewChild(AgGridAngular) agGrid!: AgGridAngular;

  constructor(private req: RequestService<any>, private router: Router) { }

  onSensorGridReady(params: GridReadyEvent) {
    this.sensorGridApi = params.api;
    this.sensorGridColumnApi = params.columnApi;
    this.req.getSensorDatasets().subscribe((res) => {
      this.sensorRowData = res;
    })
  }

  onSensorRowDoubleClick(e) {
    var selectedRows = this.sensorGridApi.getSelectedRows(e);
    this.sensorId = selectedRows[0]._id;
    this.router.navigateByUrl(`dataset/${this.sensorId}`, { state: { id: this.sensorId, fileName: this.fileName } });
  }

  onBiologicalGridReady(params: GridReadyEvent) {
    this.biologicalGridApi = params.api;
    this.biologicalGridColumnApi = params.columnApi;
    this.req.getBioDatasets().subscribe((res) => {
      this.biologicalRowData = res;
    })
  }

  onBiologicalRowDoubleClick(e) {
    var selectedRows = this.biologicalGridApi.getSelectedRows(e);
    this.biologicalId = selectedRows[0]._id;
    this.router.navigateByUrl(`dataset/${this.biologicalId}`, { state: { id: this.biologicalId, fileName: this.fileName } });
  }

  onLiteratureGridReady(params: GridReadyEvent) {
    this.literatureGridApi = params.api;
    this.literatureGridColumnApi = params.columnApi;
    this.req.getLiteratureCompendiumDatasets().subscribe((res) => {
      this.literatureRowData = res;
    })
  }

  onLiteratureRowDoubleClick(e) {
    var selectedRows = this.literatureGridApi.getSelectedRows(e);
    this.literatureId = selectedRows[0].compendium_id;
    this.router.navigateByUrl(`samples/${this.literatureId}`, { state: { id: this.literatureId } });
  }

  onPhysicochemicalGridReady(params: GridReadyEvent) {
    this.physicochemicalGridApi = params.api;
    this.physicochemicalGridColumnApi = params.columnApi;
    this.req.getPysicoDatasets().subscribe((res) => {
      this.physicochemicalRowData = res;
    })
  }

  onPhysicochemicalRowDoubleClick(e) {
    var selectedRows = this.physicochemicalGridApi.getSelectedRows(e);
    this.physicochemicalId = selectedRows[0]._id;
    this.router.navigateByUrl(`dataset/${this.physicochemicalId}`, { state: { id: this.physicochemicalId, fileName: this.fileName } });
  }

  booleanFormatter(params: any): string {
    return params.value ? 'Yes' : 'No';
  }

  ngOnInit(): void { }
}
